"use strict";

var _defineProperty = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/streamr-dev/landing-page/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackerRegistryFromContract = exports.createTrackerRegistry = exports.TrackerRegistry = void 0;

var ethers_1 = require("ethers");

var trackerRegistryConfig = __importStar(require("../../contracts/TrackerRegistry.json"));

var JsonRpcProvider = ethers_1.providers.JsonRpcProvider; // source: https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript

function hashCode(str) {
  var a = str.split('').reduce(function (prevHash, currVal) {
    return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
  }, 0);
  return Math.abs(a);
}

var TrackerRegistry = /*#__PURE__*/function () {
  function TrackerRegistry(records) {
    _classCallCheck(this, TrackerRegistry);

    this.records = records;
    this.records.sort(); // TODO does this actually sort anything?
  }

  _createClass(TrackerRegistry, [{
    key: "getTracker",
    value: function getTracker(streamId) {
      var partition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof streamId !== 'string' || streamId.indexOf('::') >= 0) {
        throw new Error("invalid id: ".concat(streamId));
      }

      if (!Number.isInteger(partition) || partition < 0) {
        throw new Error("invalid partition: ".concat(partition));
      }

      var streamKey = "".concat(streamId, "::").concat(partition);
      return this.records[hashCode(streamKey) % this.records.length];
    }
  }, {
    key: "getAllTrackers",
    value: function getAllTrackers() {
      return this.records;
    }
  }]);

  return TrackerRegistry;
}();

exports.TrackerRegistry = TrackerRegistry;

function fetchTrackers(_x, _x2) {
  return _fetchTrackers.apply(this, arguments);
}

function _fetchTrackers() {
  _fetchTrackers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(contractAddress, jsonRpcProvider) {
    var provider, contract;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = new JsonRpcProvider(jsonRpcProvider); // check that provider is connected and has some valid blockNumber

            _context.next = 3;
            return provider.getBlockNumber();

          case 3:
            contract = new ethers_1.Contract(contractAddress, trackerRegistryConfig.abi, provider); // check that contract is connected

            _context.next = 6;
            return contract.addressPromise;

          case 6:
            if (!(typeof contract.getNodes !== 'function')) {
              _context.next = 8;
              break;
            }

            throw Error("getNodes function is not defined in smart contract (".concat(contractAddress, ")"));

          case 8:
            _context.next = 10;
            return contract.getNodes();

          case 10:
            return _context.abrupt("return", _context.sent);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchTrackers.apply(this, arguments);
}

function createTrackerRegistry(servers) {
  return new TrackerRegistry(servers);
}

exports.createTrackerRegistry = createTrackerRegistry;

function getTrackerRegistryFromContract(_x3) {
  return _getTrackerRegistryFromContract.apply(this, arguments);
}

function _getTrackerRegistryFromContract() {
  _getTrackerRegistryFromContract = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var contractAddress, jsonRpcProvider, trackers, records, i, _trackers$i, metadata, url, nodeAddress, urls;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            contractAddress = _ref.contractAddress, jsonRpcProvider = _ref.jsonRpcProvider;
            _context2.next = 3;
            return fetchTrackers(contractAddress, jsonRpcProvider);

          case 3:
            trackers = _context2.sent;
            records = [];
            i = 0;

          case 6:
            if (!(i < trackers.length)) {
              _context2.next = 19;
              break;
            }

            _trackers$i = trackers[i], metadata = _trackers$i.metadata, url = _trackers$i.url, nodeAddress = _trackers$i.nodeAddress;
            _context2.prev = 8;
            // The field is tracker.metadata in newer contracts and tracker.url in old contracts.
            // It's safe to clean up tracker.url when no such contract is used anymore.
            urls = JSON.parse(metadata || url);
            records.push(_objectSpread({
              id: nodeAddress
            }, urls));
            _context2.next = 16;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](8);
            throw new Error("Element trackers[".concat(i, "] not parsable as object: ").concat(trackers[i]));

          case 16:
            ++i;
            _context2.next = 6;
            break;

          case 19:
            return _context2.abrupt("return", createTrackerRegistry(records));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 13]]);
  }));
  return _getTrackerRegistryFromContract.apply(this, arguments);
}

exports.getTrackerRegistryFromContract = getTrackerRegistryFromContract;